/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* Thunks */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/**
 * Resend invitation
 */
export const resendInvitation = createFOAsyncThunk('invitation/resendInvitation', async (arg) => {
  const { organizationId, invitationId } = arg;
  const resp = await userApi.resendInvitation(organizationId, invitationId);

  return { resp };
});
